module.exports = __webpack_public_path__ + "static/media/f-location.6c100dd7.svg";